<!--
  @component
  A component representing a list of items in the shopping cart.

  @prop css - Custom CSS styles for the component
  @prop children - A Svelte snippet containing the cart items

  @example
  <CartItemList css={{ padding: '1rem' }}>
    {#each cartItems as item}
      <CartItem {item} />
    {/each}
  </CartItemList>
-->

<script lang="ts" module>
  import type { SystemStyleObject } from '@agapi/ui/panda/types';
  import type { Snippet } from 'svelte';

  export type CartItemListProps = {
    /** A Svelte snippet containing the cart items. */
    children?: Snippet
    css?: SystemStyleObject;
  };
</script>

<script lang="ts">
  import { css } from '@agapi/ui/panda/css';
  import { cartItemListStyles } from './cart-item-list.styles';

  const { css: cssProp, children }: CartItemListProps = $props();
  const classes = cartItemListStyles.raw();
</script>

<ul class={css(classes.root, cssProp)}>
  {@render children?.()}
</ul>
